import React from 'react';
import PropTypes from 'prop-types';
import { ordinalize } from '../../../../../numberUtils';
import { interviewAvailabilityShape } from '../../../../../dateUtils';
import InterviewAttendees from '../../../../common/InterviewSubComponents/InterviewAttendees';
import InterviewTimeRange from '../../../../common/InterviewSubComponents/InterviewTimeRange';
import InterviewTimezone from '../../../../common/InterviewSubComponents/InterviewTimezone';
function PastInterviewCard(_ref) {
  var interview = _ref.interview;
  return /*#__PURE__*/React.createElement("div", {
    className: "interview-info-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "interview-info-header past"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "medium-weight mb-8"
  }, ordinalize(interview.round_number), ' ', "round -", ' ', interview.slot_duration_minutes, ' ', "min call"), /*#__PURE__*/React.createElement(InterviewTimeRange, {
    interviewTime: interview.accepted_time,
    containerClassName: "normal-weight body-text-2 mb-4",
    opts: {
      timeZone: 'UTC',
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "normal-weight body-text-2 muted-gray-text"
  }, /*#__PURE__*/React.createElement(InterviewTimezone, {
    timezoneStr: interview.timezone,
    dateStr: interview.accepted_time.date
  }))), /*#__PURE__*/React.createElement(InterviewAttendees, {
    attendees: interview.attendees
  }));
}
PastInterviewCard.propTypes = {
  interview: PropTypes.shape({
    accepted_time: interviewAvailabilityShape,
    attendees: PropTypes.shape({
      consultant: PropTypes.string,
      invitees: PropTypes.arrayOf(PropTypes.string),
      requester: PropTypes.string
    }).isRequired,
    timezone: PropTypes.string.isRequired,
    round_number: PropTypes.number
  }).isRequired
};
export default PastInterviewCard;